import { IAbUseExperiment } from '../types/abUseExperiments';

export const DEAL_RENT_CIAN_AGENCY = 'deal_rent_cian_agency';

export const isDealRentCianAgency = (experiments: IAbUseExperiment[]): boolean => {
  const experiment = experiments.find(exp => exp.experimentName === DEAL_RENT_CIAN_AGENCY);

  return Boolean(experiment && experiment.groupName === 'enabled');
};
